const padNumber = (value, length = 2) => {
  return String(value).padStart(length, '0')
}

const normalizeFilenameSegment = (value, fallback) => {
  const normalizedValue = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  return normalizedValue === '' ? fallback : normalizedValue
}

export const formatUploadTimestamp = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value)

  if (Number.isNaN(date.getTime())) {
    return '1970-01-01-00-00-00'
  }

  return [
    date.getUTCFullYear(),
    '-',
    padNumber(date.getUTCMonth() + 1),
    '-',
    padNumber(date.getUTCDate()),
    '-',
    padNumber(date.getUTCHours()),
    '-',
    padNumber(date.getUTCMinutes()),
    '-',
    padNumber(date.getUTCSeconds()),
  ].join('')
}

export const buildGeneratedUploadFilename = ({ prefix = 'upload', extension = '', suffix = '', timestamp = new Date() } = {}) => {
  const normalizedPrefix = normalizeFilenameSegment(prefix, 'upload')
  const normalizedExtension = normalizeFilenameSegment(extension, '')
  const normalizedSuffix = normalizeFilenameSegment(suffix, '')
  const timestampSegment = formatUploadTimestamp(timestamp)
  const suffixSegment = normalizedSuffix === '' ? '' : `-${normalizedSuffix}`

  if (normalizedExtension === '') {
    return `${normalizedPrefix}-${timestampSegment}${suffixSegment}`
  }

  return `${normalizedPrefix}-${timestampSegment}${suffixSegment}.${normalizedExtension}`
}
